<template>
    <div class="page-container">
        <div class="page-head">
            <div class="head-item">
                <div class="number">{{checkedAmount}}</div>
                <div class="text">已选商品总价</div>
            </div>
            <div class="head-item">
                <div class="number">{{amount}}</div>
                <div class="text">当前可用奖励金额</div>
            </div>
        </div>
        <div class="list">
            <div class="incentive-item" v-for="(item,index) in goodsList" :key="index">
                <div class="goods-info-block">
                    <img :src="item.picUrl" class="goods-pic">
                    <div class="goods-detail">
                        <div class="goods-name">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                        <div class="goods-sku">
                            <select class="sku-select" @change="calcPrice('',{'name':index})" v-model="item.skuValue">
                                <option value="xiang">整箱(6瓶)</option>
                                <option value="ping">单瓶</option>
                            </select>
                            <van-stepper v-model="item.number" :name="index" @change="calcPrice" min="0" button-size="22" />
                        </div>
                        <div class="caigou-price">采购价：¥{{item.price}}/瓶</div>
                    </div>
                </div>
                <div class="item-bottom">总价：¥{{item.totalPrice}}</div>
            </div>
        </div>
        <div class="btn-normal" @click="jumpQr" v-if="(checkedAmount < amount) && (checkedAmount > 0)">确认兑换</div>
        <div class="btn-normal disabled" v-else>确认兑换</div>
    </div>
</template>
<script>
import { Stepper,Toast } from 'vant'
import $http from '@/lib/request'
import config from '@/config'

export default {
    data(){
        return {
            amount:0,
            goodsList:[],
            checkedAmount:0,//已选商品总价
        }
    },
    components:{
        [Stepper.name]:Stepper,
        [Toast.name]:Toast
    },
    activated(){
        $http({
            method:'post',
            url:config.api.useReferralInfo
        }).then(res=>{
            if(res.errno == 0){
                this.amount=res.data.amount;
                let tmpList=res.data.goodsList;
                for(let i=0,len=tmpList.length;i<len;i++){
                    tmpList[i].skuValue='xiang';
                    tmpList[i].number=0;
                    tmpList[i].totalPrice=tmpList[i].price * tmpList[i].number;
                }
                this.goodsList=tmpList;
            }else{
                Toast(res.errmsg);
            }
        })
    },
    methods:{
        calcPrice(value,detail){
            let list=this.goodsList;
            let index=detail.name;
            if(list[index].skuValue == 'xiang'){
                list[index].totalPrice=list[index].price * list[index].number * 6;
            }else{
                list[index].totalPrice=list[index].price * list[index].number;
            }
            this.goodsList=list;

            let he=0;
            for(let i=0;i< this.goodsList.length;i++){
                he += this.goodsList[i].totalPrice;
            }
            this.checkedAmount=he;
        },
        jumpQr(){
            let tmpData=[];
            let list=this.goodsList;
            let tmpList=[];
            for(let i=0;i<list.length;i++){
                if(list[i].number == 0){
                    continue;
                }else{
                    tmpData.push({
                        goodsId:list[i].id,
                        num:list[i].number,
                        unit:list[i].skuValue == 'xiang' ? '箱' : '瓶'
                    });
                    tmpList.push(list[i]);
                }
            }
            $http({
                method:'post',
                data:{
                    body:tmpData
                },
                url:config.api.submitDhOrder
            }).then(res=>{
                if(res.errno == 0){

                    this.$store.commit('setCurrentDhGoodsInfo',tmpList);

                    this.$router.push({
                        name:'confirm-redemption',
                        params:{
                            orderId:res.data,
                            amount:this.amount,
                            checkedAmount:this.checkedAmount,
                        }
                    });
                }else{
                    Toast(res.errmsg);
                }
            })

            
        },
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.page-container{
    background: #f5f5f5;
    min-height: 100vh;
    box-sizing: border-box;
    padding-bottom: 60px;
    .page-head{
        padding:25px 0;
        background: linear-gradient(180deg, #3CA7FE 0%, #3088F5 100%);
        display: flex;
        justify-content: center;
        align-items: flex-start;
        .head-item{
            color:#fff;
            width:50%;
            box-sizing: border-box;
            text-align: center;
            &:first-child{
                border-right: 1px solid rgba(255,255,255,0.6);
            }
            .number{
                line-height: 24px;
                font-size: 20px;
                font-weight: bold;
                font-family: DINAlternate-Bold, DINAlternate;
                margin-bottom: 5px;
            }
            .text{
                font-size: 14px;
                line-height: 20px;
                color:rgba(255,255,255,0.7);
            }
        }
    }
    .list{
        padding:10px;
        .incentive-item{
            background:#fff;
            border-radius: 4px;
            padding:0 15px;
            margin-bottom: 10px;
            .goods-info-block{
                display: flex;
                justify-content: flex-start;
                padding:15px 0;
                .goods-pic{
                    width:80px;
                    height:80px;
                    margin-right: 10px;
                    border-radius: 4px;
                }
                .goods-detail{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width:calc(100% - 70px);
                    .goods-name{
                        overflow: hidden;
                        text-overflow:ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        color:#000;
                        line-height: 20px;
                        font-size: 14px;
                    }
                    .goods-sku{
                        @include flex-between();
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                        .sku-select{
                            border:none;
                            height:20px;
                            background:#f6f6f6;
                            border-radius: 26px;
                            font-size: 12px;
                            color:#999;
                            padding:0 6px;
                        }
                    }
                    .caigou-price{
                        color:#999;
                        line-height: 18px;
                        font-size: 12px;
                    }
                }
            }
            .item-bottom{
                text-align: right;
                color:#3088F5;
                font-size: 14px;
                line-height: 20px;
                padding-bottom: 15px;
            }
        }
    }
    .btn-normal{
        width: 180px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: linear-gradient(90deg, #3088F5 0%, #3CA7FE 100%);
        border-radius: 26px;
        color:#fff;
        font-size: 16px;
        position: fixed;
        bottom:20px;
        left:50%;
        transform: translateX(-50%);
        &.disabled{
            background:#dcdcdc;
            color:#999;
        }
    }
}
</style>